import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { t } from '../../../../../../modules/infra/i18n';

const MatchesActions = ({ dismissable, restorable, className, hasItemsSelected, onDismiss, onLink, onRestore }) => (
  <div className="matches-actions">
    <button
      className={classNames(className, 'c-btn c-btn--primary')}
      disabled={!hasItemsSelected}
      type="button"
      onClick={onLink}
    >
      {t('products:shopify.link_button')}
    </button>
    <button
      className={classNames(className, 'c-btn c-btn--primary')}
      display-if={dismissable}
      disabled={!hasItemsSelected}
      type="button"
      onClick={onDismiss}
    >
      {t('products:shopify.dismiss_button')}
    </button>
    <button
      className={classNames(className, 'c-btn c-btn--primary')}
      display-if={restorable}
      disabled={!hasItemsSelected}
      type="button"
      onClick={onRestore}
    >
      {t('products:shopify.restore_button')}
    </button>
  </div>
  );

MatchesActions.propTypes = {
  dismissable: PropTypes.bool,
  restorable: PropTypes.bool,
  className: PropTypes.string,
  hasItemsSelected: PropTypes.bool,
  onDismiss: PropTypes.func.isRequired,
  onLink: PropTypes.func.isRequired,
  onRestore: PropTypes.func.isRequired,
};

MatchesActions.defaultProps = {
  dismissable: false,
  restorable: false,
  className: undefined,
  hasItemsSelected: false,
};

export default MatchesActions;
